import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ConfigService} from './config.service';
import {ConsentAudit, ConsentType} from '../model/ConsentAudit';

@Injectable()
export class ConsentService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async saveConsent(consentType: ConsentType): Promise<void> {
        const url = `${this.configService.baseUrl()}consent/`;
        await this.httpClient.post(url, {type: consentType}, {responseType: 'text'}).toPromise();
    }

    public async saveConsentAudit(consentAudit: ConsentAudit): Promise<void> {
        const url = `${this.configService.baseUrl()}consent`;
        await this.httpClient.post(url, consentAudit).toPromise();
    }

    public async getConsentForLoanApplicationAndGivenBy(loanApplicationId: string, givenByUserId: string): Promise<ConsentAudit[]> {
        const url = `${this.configService.baseUrl()}consent?loanApplicationId=${loanApplicationId}&givenBy=${givenByUserId}`;
        return await this.httpClient.get<ConsentAudit[]>(url).toPromise();
    }

    public async getConsentsForUserByType(userId: string, consentType?: ConsentType): Promise<ConsentAudit[]> {
        const url = `${this.configService.baseUrl()}consent/givenBy/${userId}`;
        if (consentType) {
            return await this.httpClient.get<ConsentAudit[]>(url, {params: new HttpParams().set('consentType', consentType)}).toPromise();
        }
        const result = await this.httpClient.get<ConsentAudit[]>(url).toPromise();
        return result;
    }
}
